var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlueShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 10,
    fill: "#D1EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 15.1717L14.2222 16.7557L17.3333 13.5878M21.7028 10.4076C21.5436 10.4158 21.3834 10.4199 21.2222 10.4199C18.8318 10.4199 16.6512 9.50488 14.9999 8C13.3487 9.50483 11.1682 10.4199 8.77778 10.4199C8.6166 10.4199 8.45638 10.4157 8.29721 10.4075C8.10321 11.1706 8 11.971 8 12.7959C8 17.2241 10.9745 20.945 15 22C19.0255 20.945 22 17.2241 22 12.7959C22 11.971 21.8968 11.1707 21.7028 10.4076Z",
    stroke: "#00A2FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueShield);
export default __webpack_public_path__ + "static/media/Icon_BlueShield.53f3bceedfe969511ec990118021823c.svg";
export { ForwardRef as ReactComponent };